import * as Yup from 'yup';

import { SOCIOECONOMIC_INFO_VALIDATION } from '~constants/validations';
import {
  POSSIBLE_STEP_STATES,
  SIMULATION_NEXT_STEP,
  STEPS_TARGETS,
  STEP_SUBMITTED_META
} from '~constants/steps';
import { mapIncumbentValue } from '~redux/Simulation/mappers';
import { camelToSnakeCase, snakeToCamelCase } from '~utils/string';
import { getIncumbentValues as getBirthIncumbentValues } from '~app/components/BirthInformation/utils';
import { getIncumbentValues as getLaborIncumbentValues } from '~app/components/LaborInformation/utils';

import { BACKEND_STEPS_SUBMITTED, STEPS_AFTER_SOCIOECONOMIC, WHEN_BUY_META_KIND } from './constants';

export const mapInitialValues = ({ birthInfo, laborInfo, whenBuy }) => ({
  gender: birthInfo?.gender || undefined,
  birthday: birthInfo?.birthday || '',
  nationality: birthInfo?.nationality || undefined,
  laborSituation: laborInfo?.employmentSituation
    ? snakeToCamelCase(laborInfo.employmentSituation)
    : undefined,
  emittedInvoicesLastYear: laborInfo?.emittedInvoicesLastYear
    ? snakeToCamelCase(laborInfo.emittedInvoicesLastYear)
    : undefined,
  monthlyIncomes: laborInfo?.incomes || '',
  jobStartDate: laborInfo?.jobStartDate || '',
  whenBuy: whenBuy || undefined
});

export const getValidationSchema = laborSituation =>
  Yup.object().shape(SOCIOECONOMIC_INFO_VALIDATION(laborSituation));

export const postSocioeconomicInfoMapper = (values, incumbent, currentNextStepMeta) => {
  const atomicDeltas = [
    ...getBirthIncumbentValues({ prefix: incumbent, values }),
    ...getLaborIncumbentValues({ prefix: incumbent, values })
  ];

  const whenBuyDelta = values.whenBuy
    ? [{ kind: WHEN_BUY_META_KIND, value: camelToSnakeCase(values.whenBuy) }]
    : [];

  const submittedMetas = BACKEND_STEPS_SUBMITTED.flatMap(stepName =>
    mapIncumbentValue(STEP_SUBMITTED_META, stepName)
  );

  const shouldUpdateNextStep = !STEPS_AFTER_SOCIOECONOMIC.includes(currentNextStepMeta);
  const nextStepMeta = shouldUpdateNextStep
    ? mapIncumbentValue(SIMULATION_NEXT_STEP, POSSIBLE_STEP_STATES[STEPS_TARGETS.CLIENT_QUOTES_INFORMATION])
    : [];

  return [...atomicDeltas, ...whenBuyDelta, ...submittedMetas, ...nextStepMeta];
};
